/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_A_USERS_ROLES } from "../graphql/getAUsersRoles.query";
import { AppNavigatorService } from "../../appNavigatorService";
import { GET_BOXES } from "../graphql/getBoxes.query";
const { toHeaderCase } = require("js-convert-case");

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface IGetAUsersRolesMethods extends IPluginMethodMap {
  getAUsersRoles(args: any): Promise<any>;
}

export class GetAUsersRolesService implements IAgentPlugin {
  readonly methods: IGetAUsersRolesMethods;

  constructor() {
    this.methods = {
      getAUsersRoles: this.getAUsersRoles.bind(this),
    };
  }

  async getAUsersRoles(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const srv = getAppNavService();

    try {
      if (client) {
        const data = await srv?.getMyProfile();

        if (data?.userEmail && is.existy(data?.userEmail)) {
          const res = await client.query({
            query: GET_A_USERS_ROLES,
            variables: {
              email: data?.userEmail,
            },
            fetchPolicy: "network-only",
          });
          if (res?.data?.getAUsersRoles?.roles) {
            res.data.getAUsersRoles.roles = this.formatRoles(
              res?.data?.getAUsersRoles?.roles,
            );
          }
          console.log(
            "res.data.getAUsersRoles.roles",
            res.data.getAUsersRoles.roles,
          );
          return res?.data?.getAUsersRoles;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatRoles(roles: any[]) {
    let _res: any = [];
    for (const role of roles) {
      _res.push({
        ...(role || {}),
        title:
          role?.name != "masq"
            ? role?.name
              ? toHeaderCase(role?.name)
              : role?.name
            : "Masq",
      });
    }
    return _res;
  }
}
